class Terms {
  public base64Data?: string;
  blobData: Blob;
}

export default Terms;